import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError, combineLatest, map, of, Subscription, switchMap, tap} from 'rxjs';
import {AuthorizationServiceProvider} from 'src/app/auth_profile/services/authorization-service.provider';
import {LangProductMapper} from 'src/app/col/utils/lang-mappers';
import {CourseFilterComponent} from "../../../utils/course-filter/course-filter.component";
import {CourseFilter, FilterDefinition} from "../../../model/CourseFilters";
import {NativeServiceApiProvider} from "../../../services/native-api-provider.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-starter-plan-page',
  templateUrl: './starter-plan-page.component.html',
  styleUrls: ['./starter-plan-page.component.scss'],
  standalone: false,
})
export class StarterPlanPageComponent implements OnInit, OnDestroy {
  studentId: number;
  currency = 'eur';
  language = 'en';
  chosenCourse: FilterDefinition | null = null

  private subscriptions = new Subscription();

  constructor(
    private auth: AuthorizationServiceProvider,
    private route: ActivatedRoute,
    private router: Router,
    private provider: NativeServiceApiProvider
  ) {}

  ngOnInit(): void {
    const studentId$ = this.auth
      .getAuthDetailsService()
      .pipe(switchMap((api) => api.getSelfStudentId()));
    const schoolId$ = this.auth
      .getAuthDetailsService()
      .pipe(switchMap((api) => api.getSelfSchoolId()));

    const language$ = this.route.queryParams.pipe(
      map((params) => String(params['language'] || 'en').toLowerCase()),
      map((lang) => (lang === 'sp' ? 'sp' : 'en')),
      tap((lang) => {
        this.language = lang
        this.chosenCourse = this.getFilter(this.language);
      })
    );

    this.subscriptions.add(
      combineLatest([studentId$, schoolId$, language$]).pipe(
        tap(([studentId]) => (this.studentId = studentId)),
        switchMap(([studentId, schoolId, lang]) => {
          if (!studentId) return of(null);
          if (!schoolId) return of(null);
          return this.provider.colV3().pipe(
            switchMap((api) => api.getProvaContext(schoolId, studentId, lang)),
            map((context) => context?.startExpiryDate ?? null),
            tap((expiry) => {
              const date = expiry ? new Date(expiry) : null
              if (!date || isNaN(date.getTime()) || date.getTime() <= new Date().getTime()) {
                // this.redirectToNotFound()
              }
            }),
            catchError(() => {
              // this.redirectToNotFound()
              return of(null)
            })
          )
        })
      ).subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getLangName() {
    return LangProductMapper.mapLangCodeToLangName(this.language);
  }

  getHeroClass() {
    return this.language === 'sp' ? 'course-sp' : 'course-en';
  }

  onCurrencyChange(currency: string): void {
    this.currency = currency;
  }

  getFilter(filterKey: string): FilterDefinition | null {
    let _filterKey = filterKey
    if (filterKey == 'en3') _filterKey = 'en'
    return CourseFilter.filtersShort.find(lang => _filterKey == lang.filter) ?? null
  }

  private redirectToNotFound() {
    const target = environment.platform.useHash ? '#/forbidden' : '/forbidden'
    this.router.navigateByUrl('/forbidden', { replaceUrl: true }).then(navigated => {
      if (!navigated) {
        window.location.replace(target)
      }
    }).catch(() => window.location.replace(target))
  }

  protected readonly CourseFilterComponent = CourseFilterComponent;
}
